import personOne from 'assets/images/bannerImages/person_1.png'
import personTwo from 'assets/images/bannerImages/person_2.png'
import personThree from 'assets/images/bannerImages/person_3.png'
import personFour from 'assets/images/bannerImages/person_4.png'
import personFive from 'assets/images/bannerImages/person_5.png'
import personSix from 'assets/images/bannerImages/person_6.png'
import personSeven from 'assets/images/bannerImages/person_7.png'
import personEight from 'assets/images/bannerImages/person_8.png'
import personNine from 'assets/images/bannerImages/person_9.png'
import personTen from 'assets/images/bannerImages/person_10.png'

export const TalentList = [
  {
    name: 'Ryan Vetrovs',
    img: personOne,
    id: 1,
  },
  {
    name: 'Matt Collins',
    img: personTwo,
    id: 1,
  },
  {
    name: 'Kierra Botosh',
    img: personThree,
    id: 1,
  },
  {
    name: 'Justin Wolman',
    img: personFour,
    id: 2,
  },
  {
    name: 'Maria Aminoff',
    img: personFive,
    id: 3,
  },
  {
    name: 'Wilson Press',
    img: personSix,
    id: 4,
  },
  {
    name: 'Ahmad Herwitz',
    img: personSeven,
    id: 5,
  },
  {
    name: 'Erin Bergson',
    img: personEight,
    id: 6,
  },
  {
    name: 'Spartak Rafal',
    img: personNine,
    id: 7,
  },
  {
    name: 'Abbott Keller',
    img: personTen,
    id: 10,
  },
]
